export default class ApiUtils {

    static buildQueryString(params) {
        return Object.keys(params).reduce((acc, key) => {
            if (acc.length > 1) acc += '&';
            if (Array.isArray(params[key])) {
                acc += params[key].reduce((acc, value, index) => {
                    acc += value;
                    if (params[key].length - 1 !== index) {
                        acc += ',';
                    }
                    return acc;
                }, `${key}=`);
            } else if (typeof params[key] === 'string'
                || typeof params[key] === 'boolean'
                || Number.isInteger(params[key])) {
                return acc += `${key}=${params[key]}`;
            }
            return acc;
        }, '?');
    }

}


// WEBPACK FOOTER //
// ./src/util/ApiUtils.js